import React, { useImperativeHandle, forwardRef, useState } from "react";

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
  createStyles,
} from "@material-ui/core";

import {
  ATALHO_VOLTAR,
  ATALHO_AVANCAR,
  SECONDARY_COLOR,
} from "../../../../../utils";
import { AutoCompleteLocal } from "../../../../../components";

const CANCELAR_VENDA_ACTION = ATALHO_VOLTAR;
const FECHAR_VENDA_ACTION = ATALHO_AVANCAR;
const ESC_ACTION = "Escape";

const options = [
  {
    id: "credito-a-vista",
    nome: "Crédito à Vista",
  },
/*   {
    id: "credito-parcelado-estabelecimento",
    nome: "Crédito Parcelado pelo Estabelecimento",
  },
  {
    id: "credito-parcelado-administradora",
    nome: "Crédito Parcelado pela Administradora",
  }, */
];

const useStyles = makeStyles((theme) =>
  createStyles({
    action: {
      display: "flex",
      justifyContent: "space-between",
    },
    root: {
      backgroundColor: theme.palette.background.paper,
    },
    button: {
      color: "white",
      backgroundColor: theme.palette.secondary.main,
    },
    disabledButton: {
      backgroundColor: "red",
    },
  })
);

const DialogoTipoCredito = forwardRef(
  ({ handleFinalizar = () => {}, handleCancelar = () => {} }, ref) => {
    const [open, setOpen] = useState(false);
    const [tipoCredito, setTipoCredito] = useState(options[0]);
    const [dados, setDados] = useState(options[0]);
    const classes = useStyles();
    const [hasCallFinishTransaction, setHasCallFinishTransaction] = useState(false);

    useImperativeHandle(ref, () => ({
      handleOpen(dados, hasCallFinishTransaction) {
        setTipoCredito(options[0]);
        setHasCallFinishTransaction(hasCallFinishTransaction)
        setOpen(true);
        setDados(dados)
      },
    }));

    const erro = tipoCredito ? "" : "Obrigatório Preencher este Campo";

    function handleActions(action) {
      switch (action) {
        case FECHAR_VENDA_ACTION: {
          handleFinalizar(tipoCredito.id, dados, hasCallFinishTransaction);
          setOpen(false)
          break;
        }
        case CANCELAR_VENDA_ACTION: {
          handleCancelar();
          setOpen(false)
          break;
        }
        case ESC_ACTION: {
          handleCancelar();
          setOpen(false)
          break;
        }
        default:
          break;
      }
      
    }

    function handleKey(keyCode, keyName) {
      handleActions(keyName);
    }

    return (
      <div>
        <Dialog
          open={open}
          onClose={handleCancelar}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          disableBackdropClick
          disableEscapeKeyDown
          fullWidth
          maxWidth="sm"
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{
              color: "white",
              backgroundColor: SECONDARY_COLOR,
              textAlign: "center",
            }}
          >
            {`Tipo de Crédito`}
          </DialogTitle>
          <DialogContent
            style={{
              padding: "20px 10px",
            }}
          >
            <div>
              <AutoCompleteLocal
                handleEnter={() => {handleActions(FECHAR_VENDA_ACTION);}}
                label=""
                handleKey={handleKey}
                value={tipoCredito}
                onChangeLocal={(value) => {
                  setTipoCredito(value);
                }}
                error={erro !== ""}
                helperText={erro}
                campo="nome"
                options={options}
                variant="standard"
                autoFocus
              />
            </div>
          </DialogContent>
          <DialogActions className={classes.action}>
            <Button
              onClick={() => handleActions(CANCELAR_VENDA_ACTION)}
              color="secondary"
              variant="contained"
              tabindex="-1"
            >
              {`Cancelar (${CANCELAR_VENDA_ACTION})`}
            </Button>
            <Button
              color="secondary"
              variant="contained"
              onClick={() => handleActions(FECHAR_VENDA_ACTION)}
              tabindex="-1"
              disabled={tipoCredito ? false : true}
            >
              {`Avançar (${FECHAR_VENDA_ACTION})`}
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
);

export default DialogoTipoCredito;
